export default [
	{
		'model': 'E30',
		'price': '41875',
		'excavatorOperatingWeightMax(t)': '36',
		'annualOperatingHours(h)': '4000',
		'constantValueForEstimatedMachineLifetime': '20000',
		'estimatedMachineLifetime': '20000',
		'production,(Tonnes/hour)': '300',
		'tramming(%)': '15',
		'undercarriageLifetime(h)': '9000',
		'averageUndercarriageRebuildCost(€)(fullMidlifeRebuildIncl.Motors,FinalsRollers,SproketsEtc.)':
			'64000',
		'revenuePerTonne($)': '0,90',
		'labourHoursForUndercarriageMaintenanceDuringLifetime': '328',
		'labourCostPerHourForMaintenance': '50',
		'maintenanceCostPerHour($)(Parts+Fluids,ExcludingUndercarriageRelatedParts)': '9',
		'undercarriageCostPerHour($)(OnlyUndercarriageRelatedParts)': '6,4',
		'averageTravellingSpeedOnTracks(km/h)': '3',
		'averageTravellingSpeedOnSleipners(km/h)': '13',
		'averageFuelPrice($/l)': '1,2',
		'fuelConsumptionW/OSleipner(liters/hour)': '30',
		'fuelConsumptionWSleipner(liters/hour)': '2,3',
		'ownershipCosts': '14,7',
	},
	{
		'model': 'E50',
		'price': '62625',
		'excavatorOperatingWeightMax(t)': '58',
		'annualOperatingHours(h)': '4000',
		'estimatedMachineLifetime': '20000',
		'constantValueForEstimatedMachineLifetime': '20000',
		'production,(Tonnes/hour)': '450',
		'tramming(%)': '15',
		'undercarriageLifetime(h)': '10000',
		'averageUndercarriageRebuildCost(€)(fullMidlifeRebuildIncl.Motors,FinalsRollers,SproketsEtc.)':
			'96000',
		'revenuePerTonne($)': '0,90',
		'labourHoursForUndercarriageMaintenanceDuringLifetime': '396',
		'labourCostPerHourForMaintenance': '50',
		'maintenanceCostPerHour($)(Parts+Fluids,ExcludingUndercarriageRelatedParts)': '14',
		'undercarriageCostPerHour($)(OnlyUndercarriageRelatedParts)': '9,6',
		'averageTravellingSpeedOnTracks(km/h)': '3',
		'averageTravellingSpeedOnSleipners(km/h)': '13',
		'averageFuelPrice($/l)': '1,2',
		'fuelConsumptionW/OSleipner(liters/hour)': '42',
		'fuelConsumptionWSleipner(liters/hour)': '4,7',
		'ownershipCosts': '16,6',
	},
	{
		'model': 'E70',
		'price': '117250',
		'excavatorOperatingWeightMax(t)': '77',
		'annualOperatingHours(h)': '4000',
		'estimatedMachineLifetime': '30000',
		'constantValueForEstimatedMachineLifetime': '30000',
		'production,(Tonnes/hour)': '600',
		'tramming(%)': '14',
		'undercarriageLifetime(h)': '12000',
		'averageUndercarriageRebuildCost(€)(fullMidlifeRebuildIncl.Motors,FinalsRollers,SproketsEtc.)':
			'120000',
		'revenuePerTonne($)': '0,90',
		'labourHoursForUndercarriageMaintenanceDuringLifetime': '432',
		'labourCostPerHourForMaintenance': '50',
		'maintenanceCostPerHour($)(Parts+Fluids,ExcludingUndercarriageRelatedParts)': '20',
		'undercarriageCostPerHour($)(OnlyUndercarriageRelatedParts)': '10',
		'averageTravellingSpeedOnTracks(km/h)': '3',
		'averageTravellingSpeedOnSleipners(km/h)': '12',
		'averageFuelPrice($/l)': '1,2',
		'fuelConsumptionW/OSleipner(liters/hour)': '52',
		'fuelConsumptionWSleipner(liters/hour)': '6,5',
		'ownershipCosts': '19,9',
	},
	{
		'model': 'E90',
		'price': '152250',
		'excavatorOperatingWeightMax(t)': '98',
		'annualOperatingHours(h)': '6000',
		'estimatedMachineLifetime': '30000',
		'constantValueForEstimatedMachineLifetime': '30000',
		'production,(Tonnes/hour)': '750',
		'tramming(%)': '14',
		'undercarriageLifetime(h)': '12000',
		'averageUndercarriageRebuildCost(€)(fullMidlifeRebuildIncl.Motors,FinalsRollers,SproketsEtc.)':
			'176000',
		'revenuePerTonne($)': '0,90',
		'labourHoursForUndercarriageMaintenanceDuringLifetime': '432',
		'labourCostPerHourForMaintenance': '50',
		'maintenanceCostPerHour($)(Parts+Fluids,ExcludingUndercarriageRelatedParts)': '22',
		'undercarriageCostPerHour($)(OnlyUndercarriageRelatedParts)': '14,7',
		'averageTravellingSpeedOnTracks(km/h)': '2,5',
		'averageTravellingSpeedOnSleipners(km/h)': '12',
		'averageFuelPrice($/l)': '1,2',
		'fuelConsumptionW/OSleipner(liters/hour)': '68',
		'fuelConsumptionWSleipner(liters/hour)': '7,5',
		'ownershipCosts': '22,1',
	},
	{
		'model': 'E120',
		'price': '194875',
		'excavatorOperatingWeightMax(t)': '124',
		'annualOperatingHours(h)': '6000',
		'estimatedMachineLifetime': '45000',
		'constantValueForEstimatedMachineLifetime': '45000',
		'production,(Tonnes/hour)': '950',
		'tramming(%)': '13',
		'undercarriageLifetime(h)': '15000',
		'averageUndercarriageRebuildCost(€)(fullMidlifeRebuildIncl.Motors,FinalsRollers,SproketsEtc.)':
			'280000',
		'revenuePerTonne($)': '0,90',
		'labourHoursForUndercarriageMaintenanceDuringLifetime': '528',
		'labourCostPerHourForMaintenance': '50',
		'maintenanceCostPerHour($)(Parts+Fluids,ExcludingUndercarriageRelatedParts)': '24',
		'undercarriageCostPerHour($)(OnlyUndercarriageRelatedParts)': '18,7',
		'averageTravellingSpeedOnTracks(km/h)': '2',
		'averageTravellingSpeedOnSleipners(km/h)': '11',
		'averageFuelPrice($/l)': '1,2',
		'fuelConsumptionW/OSleipner(liters/hour)': '70',
		'fuelConsumptionWSleipner(liters/hour)': '13,6',
		'ownershipCosts': '23,7',
	},
	{
		'model': 'E190',
		'price': '374125',
		'excavatorOperatingWeightMax(t)': '210',
		'annualOperatingHours(h)': '6000',
		'estimatedMachineLifetime': '45000',
		'constantValueForEstimatedMachineLifetime': '45000',
		'production,(Tonnes/hour)': '1300',
		'tramming(%)': '12',
		'undercarriageLifetime(h)': '16000',
		'averageUndercarriageRebuildCost(€)(fullMidlifeRebuildIncl.Motors,FinalsRollers,SproketsEtc.)':
			'456000',
		'revenuePerTonne($)': '0,90',
		'labourHoursForUndercarriageMaintenanceDuringLifetime': '688',
		'labourCostPerHourForMaintenance': '80',
		'maintenanceCostPerHour($)(Parts+Fluids,ExcludingUndercarriageRelatedParts)': '49',
		'undercarriageCostPerHour($)(OnlyUndercarriageRelatedParts)': '28,5',
		'averageTravellingSpeedOnTracks(km/h)': '1,5',
		'averageTravellingSpeedOnSleipners(km/h)': '10',
		'averageFuelPrice($/l)': '1,2',
		'fuelConsumptionW/OSleipner(liters/hour)': '94',
		'fuelConsumptionWSleipner(liters/hour)': '19,2',
		'ownershipCosts': '49,4',
	},
	{
		'model': 'E250',
		'price': '433375',
		'excavatorOperatingWeightMax(t)': '260',
		'annualOperatingHours(h)': '6000',
		'estimatedMachineLifetime': '60000',
		'constantValueForEstimatedMachineLifetime': '60000',
		'production,(Tonnes/hour)': '1500',
		'tramming(%)': '11',
		'undercarriageLifetime(h)': '17000',
		'averageUndercarriageRebuildCost(€)(fullMidlifeRebuildIncl.Motors,FinalsRollers,SproketsEtc.)':
			'672000',
		'revenuePerTonne($)': '0,9',
		'labourHoursForUndercarriageMaintenanceDuringLifetime': '1008',
		'labourCostPerHourForMaintenance': '80',
		'maintenanceCostPerHour($)(Parts+Fluids,ExcludingUndercarriageRelatedParts)': '56',
		'undercarriageCostPerHour($)(OnlyUndercarriageRelatedParts)': '37,3',
		'averageTravellingSpeedOnTracks(km/h)': '1,2',
		'averageTravellingSpeedOnSleipners(km/h)': '10',
		'averageFuelPrice($/l)': '1,2',
		'fuelConsumptionW/OSleipner(liters/hour)': '146',
		'fuelConsumptionWSleipner(liters/hour)': '22,5',
		'ownershipCosts': '55,5',
	},
	{
		'model': 'E310',
		'price': '597750',
		'excavatorOperatingWeightMax(t)': '310',
		'annualOperatingHours(h)': '6000',
		'estimatedMachineLifetime': '60000',
		'constantValueForEstimatedMachineLifetime': '60000',
		'production,(Tonnes/hour)': '1800',
		'tramming(%)': '10',
		'undercarriageLifetime(h)': '17000',
		'averageUndercarriageRebuildCost(€)(fullMidlifeRebuildIncl.Motors,FinalsRollers,SproketsEtc.)':
			'840000',
		'revenuePerTonne($)': '0,9',
		'labourHoursForUndercarriageMaintenanceDuringLifetime': '1456',
		'labourCostPerHourForMaintenance': '80',
		'maintenanceCostPerHour($)(Parts+Fluids,ExcludingUndercarriageRelatedParts)': '84',
		'undercarriageCostPerHour($)(OnlyUndercarriageRelatedParts)': '46,7',
		'averageTravellingSpeedOnTracks(km/h)': '1,1',
		'averageTravellingSpeedOnSleipners(km/h)': '9',
		'averageFuelPrice($/l)': '1,2',
		'fuelConsumptionW/OSleipner(liters/hour)': '174',
		'fuelConsumptionWSleipner(liters/hour)': '25,6',
		'ownershipCosts': '83,2',
	},
	{
		'model': 'E400',
		'price': '762125',
		'excavatorOperatingWeightMax(t)': '407',
		'annualOperatingHours(h)': '6000',
		'estimatedMachineLifetime': '60000',
		'constantValueForEstimatedMachineLifetime': '60000',
		'production,(Tonnes/hour)': '2400',
		'tramming(%)': '9',
		'undercarriageLifetime(h)': '16000',
		'averageUndercarriageRebuildCost(€)(fullMidlifeRebuildIncl.Motors,FinalsRollers,SproketsEtc.)':
			'1280000',
		'revenuePerTonne($)': '0,9',
		'labourHoursForUndercarriageMaintenanceDuringLifetime': '2076',
		'labourCostPerHourForMaintenance': '80',
		'maintenanceCostPerHour($)(Parts+Fluids,ExcludingUndercarriageRelatedParts)': '123',
		'undercarriageCostPerHour($)(OnlyUndercarriageRelatedParts)': '71,1',
		'averageTravellingSpeedOnTracks(km/h)': '1',
		'averageTravellingSpeedOnSleipners(km/h)': '8',
		'averageFuelPrice($/l)': '1,2',
		'fuelConsumptionW/OSleipner(liters/hour)': '235',
		'fuelConsumptionWSleipner(liters/hour)': '33,9',
		'ownershipCosts': '123,1',
	},
	{
		'model': 'E550',
		'price': '1439375',
		'excavatorOperatingWeightMax(t)': '570',
		'annualOperatingHours(h)': '6000',
		'estimatedMachineLifetime': '60000',
		'constantValueForEstimatedMachineLifetime': '60000',
		'production,(Tonnes/hour)': '3300',
		'tramming(%)': '8',
		'undercarriageLifetime(h)': '16000',
		'averageUndercarriageRebuildCost(€)(fullMidlifeRebuildIncl.Motors,FinalsRollers,SproketsEtc.)':
			'1540000',
		'revenuePerTonne($)': '0,9',
		'labourHoursForUndercarriageMaintenanceDuringLifetime': '2220',
		'labourCostPerHourForMaintenance': '80',
		'maintenanceCostPerHour($)(Parts+Fluids,ExcludingUndercarriageRelatedParts)': '156',
		'undercarriageCostPerHour($)(OnlyUndercarriageRelatedParts)': '85,5',
		'averageTravellingSpeedOnTracks(km/h)': '0,9',
		'averageTravellingSpeedOnSleipners(km/h)': '7',
		'averageFuelPrice($/l)': '1,2',
		'fuelConsumptionW/OSleipner(liters/hour)': '298',
		'fuelConsumptionWSleipner(liters/hour)': '55',
		'ownershipCosts': '156',
	},
];
